import React from "react";
import Container from "../components/misc/Container";
import { Link } from "react-router-dom";
import LayoutHomepage from "../layout/LayoutHomepage";
import Food from "../assets/images/food@2x.png";
import Brokoli from "../assets/images/brokoli.png";
// Import Icon
import { ReactComponent as ClockIcon } from "../assets/icons/icon-ios-timer.svg";
import { ReactComponent as ForkIcon } from "../assets/icons/icon-fork-eat.svg";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";

const RecipeDetails = () => {
  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2">
              <div className="flex w-full mb-2 mt-8">
                <p className="flex items-center text-font-gray opacity-50">
                  <Link to="/homepage">Beranda </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                  <Link to="/recipe">Resep</Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                <p className="flex items-center text-font-gray">
                  Soto Ayam lamongan
                </p>
              </div>
              <div className="flex">
                <div className="flex">
                  <div className="border rounded-md bg-white mb-8 mr-8 mt-8">
                    <img alt="food beneran" className="m-4 rounded-md" src={Food} />
                  </div>
                </div>
                <div className="flex-grow rounded overflow-hidden shadow-lg flex flex-col justify-center items-center pl-12">
                  <div className="flex justify-start flex-col w-full">
                    <h1 className="text-3xl font-bold text-left">
                      Soto Ayam lamongan
                    </h1>
                    <div className="bg-white rounded-lg flex justify-center align-center mt-4 w-9/12 shadow-sm">
                      <div className="px-6 py-3 flex items-center w-full">
                        <div className="flex items-center">
                          <ClockIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">1 Jam</p>
                        </div>

                        <div className="flex items-center mx-auto">
                          <ForkIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">4 Porsi</p>
                        </div>
                        <span className=" font-semibold text-green-100 bg-greenlight-100 border border-green-100 px-4 py-1 rounded-md">
                          Mudah
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h1 className="text-2xl semi-bold mt-4 mb-2">Bahan Baku</h1>
              <div className="flex">
                <div className="flex flex-wrap w-full -mx-2">
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                  {/* Items  */}
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={Brokoli} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">Brokoli</p>
                        <p className="text-font-gray-text text-xs">250gram</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.0000</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  {/* End Items  */}
                </div>
              </div>
              <h1 className="text-2xl font-semibold mb-2 mt-4">Bahan Bahan</h1>
              <div className="flex w-full">
                <div className="flex-wrap mr-10 mb-10 ">
                  <div className="bg-white p-10">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bahan</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">700g</div>
                      <div className="flex-wrap">Ayam kampung</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">5pcs</div>
                      <div className="flex-wrap">Daun jeruk</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2 btng</div>
                      <div className="flex-wrap">Batang serai</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">1 sdk</div>
                      <div className="flex-wrap">Minyak goreng</div>
                    </div>
                  </div>
                  <div className="bg-white p-10 ">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bumbu halus</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">12pcs</div>
                      <div className="flex-wrap">Bawang merah</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2cm</div>
                      <div className="flex-wrap">Jahe</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">4 pcs</div>
                      <div className="flex-wrap">Kemiri</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">8cm</div>
                      <div className="flex-wrap">Kunyit bakar</div>
                    </div>
                  </div>
                  <div className="bg-white p-10">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bumbu pelengkap</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">2 btg</div>
                      <div className="flex-wrap">
                        Daun seledri, cincang halus
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">200 gr</div>
                      <div className="flex-wrap">Kol iris halus</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2 bh</div>
                      <div className="flex-wrap">Tomat, potong kasar</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">3 bh</div>
                      <div className="flex-wrap">Telur ayam rebus</div>
                    </div>
                  </div>
                </div>
                <div className="flex-wrap w-8/12 ">
                  <div className="flex flex-col bg-white rounded">
                    <div className="p-4">
                      <h1 className="font-bold text-xl text-basic-orange text-center">
                        Cara membuat
                      </h1>
                      <ul className="mt-4">
                        <li className="m-8">
                          1. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                        <li className="m-8">
                          2. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                        <li className="m-8">
                          3. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                        <li className="m-8">
                          4. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                        <li className="m-8">
                          5. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                        <li className="m-8">
                          6. Dalam panci, rebus air dan ayam dg api kecil.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default RecipeDetails;
